import React from 'react'
import { Modal } from 'antd'
import { modalTheme } from './modalTheme'
import { modalCopy } from './modalCopy'

interface AccessGuideModalOptions {
  accessInfo?: any
  content: string
  onPersonalPay?: () => void
}

export const showAccessGuideModal = ({ accessInfo, content, onPersonalPay }: AccessGuideModalOptions) => {
  const canPersonalPay = accessInfo?.show_personal_pay_cta == 1

  Modal.confirm({
    title: modalCopy.accessGuideTitle,
    icon: null,
    width: modalTheme.modalWidthAccess,
    centered: true,
    content: (
      <div style={{ paddingTop: 2 }}>
        <div
          style={{
            padding: `${modalTheme.spacingLg}px ${modalTheme.spacingXl}px`,
            background: modalTheme.accessWarnBg,
            border: `1px solid ${modalTheme.accessWarnBorder}`,
            borderRadius: modalTheme.radiusMd,
            color: modalTheme.accessWarnText,
            lineHeight: modalTheme.lineHeightRelaxed,
          }}
        >
          {content}
        </div>
        {accessInfo?.effective_authorized_end_date ? (
          <div style={{ marginTop: modalTheme.spacingSm, color: modalTheme.accessExpireText, fontSize: modalTheme.fontSm }}>
            {modalCopy.accessGuideExpirePrefix}{accessInfo?.effective_authorized_end_date}
          </div>
        ) : null}
        <div
          style={{
            marginTop: modalTheme.spacingMd,
            padding: `${modalTheme.spacingMd}px ${modalTheme.spacingLg}px`,
            background: modalTheme.contactCardBg,
            borderRadius: modalTheme.radiusSm,
            color: modalTheme.contactCardText,
          }}
        >
          {modalCopy.accessGuidePhonePrefix}<span style={{ color: modalTheme.contactPhoneText, fontWeight: 600 }}>{accessInfo?.sales_contact || modalCopy.defaultSalesPhone}</span>
        </div>
      </div>
    ),
    okText: canPersonalPay ? modalCopy.accessGuideOkPay : modalCopy.accessGuideOkKnow,
    cancelText: modalCopy.accessGuideCancel,
    okCancel: canPersonalPay,
    okButtonProps: {
      style: canPersonalPay
        ? {
            background: modalTheme.primaryGradient,
            borderColor: '#0ea5e9',
          }
        : undefined,
    },
    cancelButtonProps: {
      style: {
        borderColor: modalTheme.secondaryButtonBorder,
        color: modalTheme.secondaryText,
      },
    },
    onOk: () => {
      if (canPersonalPay && onPersonalPay) {
        onPersonalPay()
      }
    },
  })
}
